"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatTabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const elements_1 = require("../../elements");
const ChatTab = styled_1.default.div((props) => ({
    alignItems: 'center',
    backgroundColor: props.active ? constants_1.Color.WHITE : constants_1.Color.GREY,
    color: props.active ? constants_1.Color.CHARCOAL : constants_1.Color.DARK_GREY,
    cursor: props.active ? undefined : 'pointer',
    display: 'flex',
    flexGrow: 1,
    fontSize: constants_1.theme.font.size[6],
    fontWeight: props.active ? constants_1.theme.font.weight.bold : undefined,
    gap: 8,
    height: 40,
    justifyContent: 'center',
    textAlign: 'center',
    userSelect: 'none',
    width: '100%',
}));
const ChatTabs = (props) => {
    return ((0, jsx_runtime_1.jsx)(elements_1.Flex, { styles: { backgroundColor: constants_1.Color.WHITE, width: '100%', ...props.styles }, children: props.tabs.map((tab) => ((0, jsx_runtime_1.jsxs)(ChatTab, { active: props.activeTab === tab.name, onClick: () => props.onActivate(tab.name), children: [tab.children, tab.badge && ((0, jsx_runtime_1.jsx)(elements_1.Badge, { ...tab.badge, size: "xs", squared: true, styles: {
                        fontWeight: constants_1.theme.font.weight.medium,
                        whiteSpace: 'nowrap',
                    } }))] }, tab.name))) }));
};
exports.ChatTabs = ChatTabs;
